import apiClient from "./api";

export interface SupportIntegration {
  id: string;
  name: string;
  providerType: string;
  status: string;
  tokenExpiresAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProviderInbox {
  id: string;
  name: string;
}

export interface WidgetHandoffSettings {
  handoffEnabled: boolean;
  handoffSupportIntegrationId?: string | null;
  handoffInboxId?: string | null;
  handoffInboxName?: string | null;
  handoffLevel?: number;
}

export const integrationService = {
  listIntegrations: async (): Promise<SupportIntegration[]> => {
    const response = await apiClient.get("/integrations/support");
    return response.data;
  },

  beginHelpScoutOAuth: async (
    integrationId?: string,
  ): Promise<{ authorizationUrl: string }> => {
    const response = await apiClient.post(
      "/integrations/support/helpscout/auth",
      undefined,
      {
        params: integrationId ? { integrationId } : undefined,
      },
    );
    return response.data;
  },

  beginIntercomOAuth: async (): Promise<{ authorizationUrl: string }> => {
    const response = await apiClient.post(
      "/integrations/support/intercom/auth",
    );
    return response.data;
  },

  connectIntercomWithToken: async (
    accessToken: string,
    name?: string,
    clientSecret?: string,
  ): Promise<void> => {
    await apiClient.post("/integrations/support/intercom/token", {
      accessToken,
      name,
      clientSecret,
    });
  },

  renameIntegration: async (
    integrationId: string,
    name: string,
  ): Promise<void> => {
    await apiClient.patch(`/integrations/support/${integrationId}`, { name });
  },

  deleteIntegration: async (integrationId: string): Promise<void> => {
    await apiClient.delete(`/integrations/support/${integrationId}`);
  },

  listInboxes: async (integrationId: string): Promise<ProviderInbox[]> => {
    const response = await apiClient.get(
      `/integrations/support/${integrationId}/inboxes`,
    );
    return response.data;
  },

  updateWidgetHandoffSettings: async (
    widgetId: string,
    settings: WidgetHandoffSettings,
  ): Promise<void> => {
    await apiClient.put(`/widget/${widgetId}/handoff-settings`, settings);
  },
};
